import { AuthGuestProvider } from '@/auth/AuthGuestProvider.js';
import { ApiClient } from '@/services/ApiClient.js';
import { defineService } from '@nzyme/ioc/Service.js';
import { FileUploadUrlProvider } from '@sigma/client/files/FileUploadUrlProvider.js';
import { FileUploadEndpoint } from '@sigma/patient-api/files/FileUploadEndpoint.js';

/**
 * Patient-app implementation of FileUploadUrlProvider.
 * Initializes guest auth if needed, then delegates to the patient FileUploadEndpoint.
 */
export const PatientFileUploadUrlProvider = defineService({
    name: 'PatientFileUploadUrlProvider',
    implements: FileUploadUrlProvider,
    deps: {
        api: ApiClient,
        authGuestProvider: AuthGuestProvider,
    },
    setup({ api, authGuestProvider }): FileUploadUrlProvider {
        return async params => {
            if (!params.chatId) {
                throw new Error('chatId is required for patient file upload');
            }

            // Initialize guest if not logged in
            await authGuestProvider.initialize();

            return await api(FileUploadEndpoint, {
                chatId: params.chatId,
                name: params.name,
                contentType: params.contentType,
                size: params.size,
                width: params.width,
                height: params.height,
            });
        };
    },
});
